import moment from 'moment-timezone';

const timezone = moment.tz.guess();

// Override for the default relative time format.
moment.updateLocale('en', {
  relativeTime: {
    s: 'Now',
    ss: 'Now',
    m: '1m',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: '1d',
  },
  week: {
    dow: 1,
  },
});

export default function (date = null, dateOnEmpty = true, unix = false) {
  if (!date) {
    return dateOnEmpty ? moment() : moment;
  }

  if (unix) {
    return moment.unix(date).utc().tz(timezone);
  }
  return moment.utc(date).tz(timezone);
}
